import { View } from 'backbone.marionette';
import templates from './templates';
import './index.styl';
import Radio from 'backbone.radio';
import { Model } from 'backbone';

const leagueChannel = Radio.channel( 'league' );

/**
 * @desc Regeneration Header View
 */
export default class RegenerationHeaderView extends View {
	get template() {
		let step_number = this.getOption( 'step_number' );

		switch ( step_number ) {
			case 'step1':
				return templates.step1;
			case 'step2':
				return templates.step2;
			case 'step3':
				return templates.step3;
			case 'step4':
				return templates.step4;
			default:
				return templates.step1;
		}
	}

	get className() {
		return 'league-regeneration-header';
	}

	initialize() {
		this.model = new Model( {
			name: ''
		} );

		this.initListeners();
	}

	initListeners() {
		this.listenTo( leagueChannel, 'league:query:response', this.updateData );
	}

	updateData( data ) {
		this.model.set( data );
		this.render();
	}
}